import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Button, Container, Paper, makeStyles, Typography } from '@material-ui/core';

export interface IHomePageProps {

}

const useStyles = makeStyles(theme => ({
    home: {
        padding: theme.spacing(3),
        marginTop: theme.spacing(3)
    },
    button: {
        padding: theme.spacing(3, 0),
        textAlign: 'center'
    }
}));

const HomePage: React.FunctionComponent<IHomePageProps> = ({

}) => {
    const classes = useStyles();

    return (
        <Container>
            <Typography variant="h1">
                Quickbooks Importer
            </Typography>
            <Paper className={classes.home}>
                <Typography>
                    To begin importing IIF files into Quickbooks Online login.
                </Typography>
                <div className={classes.button}>
                    <Button color="primary" variant="contained" component="a" href="/auth/quickbooks" size="large">Login</Button>
                </div>
            </Paper>
        </Container>
    )
}

export default HomePage;



// WEBPACK FOOTER //
// ./src/pages/HomePage.tsx